
import React, { useState } from 'react';
import { ArrowRight, ChevronLeft, Check, Sparkles } from 'lucide-react';

interface OnboardingStep4Props {
  onComplete: (goals: string[]) => void;
  onBack: () => void;
}

export const OnboardingStep4: React.FC<OnboardingStep4Props> = ({ onComplete, onBack }) => {
  const allGoals = [
    { id: 'expenses', label: 'Controlar gastos minuciosamente' },
    { id: 'prices', label: 'Obter os melhores preços de materiais' },
    { id: 'decisions', label: 'Avaliar decisões em conjunto' },
    { id: 'share', label: 'Compartilhar informações da obra' },
    { id: 'register', label: 'Registrar fotos e memórias da evolução' },
    { id: 'deadlines', label: 'Acompanhar prazos e cronograma' }
  ];

  const [selectedGoals, setSelectedGoals] = useState<string[]>(['expenses', 'register']);

  const toggleGoal = (id: string) => {
    if (selectedGoals.includes(id)) {
      setSelectedGoals(selectedGoals.filter(g => g !== id));
    } else {
      setSelectedGoals([...selectedGoals, id]);
    }
  };

  const handleFinish = () => {
    onComplete(selectedGoals);
  };

  return (
    <div className="min-h-screen mesh-gradient flex flex-col px-8 pt-12 pb-10 animate-fadeIn overflow-y-auto">
      <div className="mb-12 flex items-center gap-4">
        <button onClick={onBack} className="p-2 bg-white dark:bg-slate-900 rounded-full shadow-sm">
          <ChevronLeft size={20} className="text-slate-500" />
        </button>
        <div className="flex-1 h-2 bg-slate-200 dark:bg-slate-800 rounded-full overflow-hidden">
          <div className="h-full bg-emerald-500 w-full rounded-full transition-all duration-700 ease-out shadow-[0_0_10px_rgba(16,185,129,0.3)]"></div>
        </div>
        <span className="text-[10px] font-black text-emerald-600 uppercase tracking-widest">4 / 4</span>
      </div>

      <div className="mb-8">
        <div className="inline-flex items-center gap-2 px-3 py-1 bg-emerald-100 dark:bg-emerald-800/30 rounded-full text-[9px] font-black text-emerald-800 dark:text-emerald-400 uppercase tracking-widest mb-4">
          <Sparkles size={10} /> Toque final
        </div>
        <h2 className="text-2xl font-black text-emerald-900 dark:text-white tracking-tighter mb-4 leading-tight">
          Qual o foco principal da <br/><span className="text-emerald-600">sua jornada?</span>
        </h2>
        <p className="text-slate-600 dark:text-slate-400 text-sm font-medium leading-relaxed">
          Selecione seus objetivos para personalizarmos sua experiência.
        </p>
      </div>

      <div className="space-y-3 flex-1 mb-8">
        {allGoals.map((goal) => {
          const isSelected = selectedGoals.includes(goal.id);
          return (
            <button
              key={goal.id}
              onClick={() => toggleGoal(goal.id)}
              className={`w-full p-5 rounded-[1.5rem] border-2 transition-all flex items-center justify-between text-left group ${isSelected ? 'bg-emerald-50 border-emerald-500 dark:bg-emerald-800/20' : 'bg-white border-slate-100 dark:bg-slate-800 dark:border-slate-700'}`}
            >
              <span className={`text-sm font-bold transition-colors ${isSelected ? 'text-emerald-900 dark:text-white' : 'text-slate-500'}`}>
                {goal.label}
              </span>
              <div className={`w-6 h-6 rounded-lg flex items-center justify-center transition-all ${isSelected ? 'bg-emerald-500 text-white scale-110 shadow-lg' : 'bg-slate-100 dark:bg-slate-700 text-transparent'}`}>
                <Check size={16} strokeWidth={3} />
              </div>
            </button>
          );
        })}
      </div>

      <div className="pt-4">
        <button 
          onClick={handleFinish}
          className="w-full bg-emerald-800 dark:bg-emerald-600 text-white py-5 rounded-[2rem] font-black text-xs uppercase tracking-widest shadow-2xl flex items-center justify-center gap-3 active:scale-95 transition-all animate-pulsar-premium"
        >
          Finalizar Configuração
          <ArrowRight size={18} />
        </button>
      </div>
    </div>
  );
};